import { __awaiter } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { axiosClient } from '@as-react/common-utils';
import { PRODUCT_FREDHOPPER_SEARCH_PARAM_PLATFORM_OPTIONS } from '@as-react/common-types';
import { useAemConfig } from '@as-react/common-components';
import { ProductWizardTile, usePopoverHandlers } from '@as/cotopaxi';
import { makeGetFirstName, makeGetLoggedInState } from '../../redux/session/selectors/SessionSelector';
import { ProductWizard } from '../../components/product-wizard/ProductWizard';
const ProductWizardContainer = ({ path, trigger, loggedIn, userFirstName, }) => {
    const { defaultRequestParams, fredHopperSearchUrl, isShopLanding } = useAemConfig();
    const [data, setData] = useState(null);
    const { anchorEl, handlePopoverOpen, handlePopoverClose } = usePopoverHandlers();
    const loadProductWizardData = () => __awaiter(void 0, void 0, void 0, function* () {
        const axiosConfig = {
            method: 'GET',
            url: path,
            withCredentials: true,
        };
        try {
            const response = yield axiosClient.request(axiosConfig);
            return response.data;
        }
        catch (_a) {
            return null;
        }
    });
    const fetchSearchResults = (filter) => __awaiter(void 0, void 0, void 0, function* () {
        const axiosConfig = {
            method: 'GET',
            params: {
                anaLang: defaultRequestParams.anaLang,
                fictiveWebShop: defaultRequestParams.shopId,
                locale: defaultRequestParams.language,
                mainWebShop: defaultRequestParams.mainWebshop,
                platform: isShopLanding
                    ? PRODUCT_FREDHOPPER_SEARCH_PARAM_PLATFORM_OPTIONS.shoplanding
                    : PRODUCT_FREDHOPPER_SEARCH_PARAM_PLATFORM_OPTIONS.public_site,
            },
            url: `${fredHopperSearchUrl}?filter=${filter}`,
            withCredentials: true,
        };
        try {
            const response = yield axiosClient.request(axiosConfig);
            return response.data.itemCount;
        }
        catch (_a) {
            return null;
        }
    });
    const openProductWizard = () => __awaiter(void 0, void 0, void 0, function* () {
        const productWizardData = yield loadProductWizardData();
        if (productWizardData) {
            setData(productWizardData);
        }
    });
    useEffect(() => {
        data && handlePopoverOpen(null, null, true);
    }, [data]);
    return (_jsxs(_Fragment, { children: [_jsx(ProductWizardTile, Object.assign({}, trigger, { onClick: openProductWizard })), data && (_jsx(ProductWizard, { fetchSearchResults: fetchSearchResults, productWizardData: data, anchorEl: anchorEl, handlePopoverClose: handlePopoverClose, userFirstName: userFirstName, loggedIn: loggedIn }))] }));
};
const makeMapStateToProps = () => {
    const getFirstName = makeGetFirstName();
    const getLoggedInState = makeGetLoggedInState();
    const mapStateToProps = state => ({
        loggedIn: getLoggedInState(state),
        userFirstName: getFirstName(state),
    });
    return mapStateToProps;
};
export default connect(makeMapStateToProps)(ProductWizardContainer);
